import { getDummyText } from "../../../../utils";

export const dummyNewsBlock = {
    tag: "pressemitteilung",
    title: "Lorem ipsum dolor sit amet",
    newsBody: getDummyText(400),
    withEngTag: false,
};

export const dummyNews = [
    {
        ...dummyNewsBlock,
        withEngTag: true,
    },
    {
        ...dummyNewsBlock,
        title: "Sed ut perspiciatis unde omnis voluptas sit aspernatur aut odit aut dolor sit amet consectur",
        tag: "stories",
    },
    {
        ...dummyNewsBlock,
        title: "Nemo enim ipsam voluptatem quia",
        tag: "smart factory",
    },
    {
        ...dummyNewsBlock,
        title: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet perspiciatis unde omnis voluptas",
        tag: "news",
    },
    {
        ...dummyNewsBlock,
        title: "Ut enim ad minima veniam",
        tag: "pressemitteilungen",
    },
];
